import word from './word.json';
import sentence from './sentence.json';
import format from './format.json';
import example from './example.json';
import error_message from './error_message.json';
import validate_message from './validate_message.json';

const localefileEn = {
    ...word,
    ...sentence,
    ...format,
    ...example,
    ...error_message,
    ...validate_message,
};

export default localefileEn;
